var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImmaterialPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "35.000pt",
    height: "90.00pt",
    viewBox: "0 0 390.0000 1.0000",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1000,-0.1000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1695 5010 c-415 -63 -768 -242 -1043 -529 -316 -329 -484 -749 -484 -1206 1 -290 56 -520 189 -785 110 -219 203 -333 508 -621 113 -106 173 -170 261 -279 74 -91 196 -269 251 -365 35 -62 475 -921 528 -1032 11 -24 25 -43 32 -43 15 0 64 91 311 585 336 671 430 804 887 1260 179 177 235 241 294 328 124 184 206 375 254 592 30 137 32 506 3 660 -45 242 -118 434 -242 630 -276 441 -727 729 -1260 805 -170 24 -330 24 -489 0z m415 -440 c186 -29 356 -93 504 -188 299 -193 505 -508 577 -885 28 -145 23 -382 -9 -524 -107 -460 -431 -825 -855 -964 -471 -154 -973 -19 -1316 355 -102 110 -231 332 -274 471 -54 172 -61 224 -62 420 0 208 12 288 65 440 58 166 112 267 216 400 199 256 480 422 804 474 77 12 273 13 350 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810 4005 c-168 -168 -316 -324 -330 -347 l-25 -43 0 -505 c0 -497 0 -506 21 -545 27 -49 49 -70 97 -90 31 -13 104 -15 489 -15 423 0 456 2 495 19 50 23 78 63 133 191 23 52 45 104 50 115 59 135 176 409 186 439 19 53 19 285 0 329 -7 18 -30 48 -50 67 l-37 35 -329 5 c-180 3 -332 8 -336 12 -4 4 3 51 15 105 65 297 75 360 60 395 -15 36 -105 138 -123 138 -6 0 -149 -137 -316 -305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115 3578 c-3 -7 -4 -251 -3 -543 l3 -530 138 -3 137 -3 0 546 0 545 -135 0 c-99 0 -137 -3 -140 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmaterialPin);
export default __webpack_public_path__ + "static/media/immaterialPin.d134308aead28db08293ebc6441ba31c.svg";
export { ForwardRef as ReactComponent };